import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/MainLayout';
import { AuthContext, AuthContextState } from '../../context/AuthContext';
import { Typography, Button } from 'antd';
import NotFoundIcon from '../../assets/images/notfoundicon.png';
import { DASHBOARD_ROUTE, HOME_ROUTE } from '../../config/constants';
import styles from './NotFound.module.css';

export interface NotFoundProps {};

// default 404 not found page
const NotFound = (props: NotFoundProps): JSX.Element | null => {
  // route navigator
  const navigate = useNavigate();
  // get currently authenticated state from auth context
  const { authState } = useContext(AuthContext) as AuthContextState;

  // set document title
  useEffect(() => {
    document.title = 'Not Found | Sigmoid Academy';
  }, []);

  // handle go back home button click
  const handleGoBack = (e: React.MouseEvent<HTMLElement>): void => {
    e.preventDefault();

    // navigate to dashboard if authenticated, otherwise navigate to home
    authState ? navigate(DASHBOARD_ROUTE) : navigate(HOME_ROUTE);
  };

  return (
    <div>
      <MainLayout>
        <div className={styles.mainContainer}>
          <Typography.Title
            className={styles.mainHeading}
            level={2}
          >
            Oops! Looks like you wandered into uncharted data territory.
          </Typography.Title>
          <Typography.Title
            className={styles.mainHeadingSmall}
            level={4}
          >
            Oops! Looks like you wandered into uncharted data territory.
          </Typography.Title>
          <img src={NotFoundIcon} alt={'Not Found Icon'} className={styles.mainIcon} />
          <Button
            type='primary'
            className='mainButton'
            onClick={handleGoBack}
          >
            Go Back Home
          </Button>
        </div>
      </MainLayout>
    </div>
  );
};

export default NotFound;
